/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const UsaIcon = ({ width = 24, height = 24, hidden = false, title = 'Usa' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10.759 24.537c.155-1.229 1.871.729 1.945.785.452.335.8 1.021 1.36 1.211.266.09.564-.538.672-.488.958.445 2.095 2.823 3.011 3.019.807.172 1.435-2.763 3.135-3.173.627-.151 3.181.647 3.413.326.022-.03-.806-.646-.287-.888.045-.022 1.356-.64.912-.64.916 0 5.156.96 4.309 1.845a4.063 4.063 0 0 0 1.576 1.959c-.181.09-.088.366-.042.54 1.954-1.213-1.335-3.991-1.165-5.525.067-.6 2.671-4.169 2.993-3.931-.21.007.135-.354.121-.7-.08-.137-2.064-3.053-1.01-3.053-.214.368.544 1.928.533 1.925a10.079 10.079 0 0 1 .216-1.584c.567 0 .113-1.339.193-1.469.2-.327.72-.77.959-1.134s1.285-.579.486-1.428c-.59-.626.009-.755.323-1.421.155-.329 1.044-.69.983-1.342.012.127-1.389-1.507-1.2-1.469-1.945-.38-.406.844-.989 1.584a14.382 14.382 0 0 1-2.6 2.38c-.172.133-3.813 4.18-3.966 3.293.013.076.507-2.484-.275-2.012l-.344.512c-.388 0 .454-1.161-.18-1.368-1.428-.467-.522.559-1.07.559-1.227-.2.584 2.08-.388 2.686-1.14.45-.285-2.827-.471-3.039a2.583 2.583 0 0 1-.575.838c-.818-1.235 2.082-1.371 2.257-1.614-.065-.057-.908-.62-.8-.572.043.02-1.887.33-2 .373a.723.723 0 0 0 .344-.64c-.721-.32-1.047 1.039-1.5.64a8.068 8.068 0 0 1-.948.344c0-.252 1.41-1.151 1.347-1.247a15.362 15.362 0 0 1-3.139-.8A31.491 31.491 0 0 1 4.063 8.332c-.321.288.445.8-.03 1.075a8.942 8.942 0 0 1-1-.847c-.276.074-1.059 4.985-1.146 5.363-.034.146-1.115 4.194.065 3.468a3.292 3.292 0 0 0 .035.545.809.809 0 0 0-.243-.237c-1.338.944 2.164 4.281 2.8 4.667.568.348 6.166 2.606 6.222 2.171.058-.515-.019.092-.007 0Zm23.126-12.746Z"
    />
  </svg>`;
};
